import axios from 'axios';
import router from '@/router';
import { getToken, logoutFromApp, onKeycloakReady } from '@/plugins/keycloak';

let baseUrl = process.env.VUE_APP_API_BASE_URL;

if (process.env.NODE_ENV !== 'development') {
  baseUrl = window.location.origin;
}

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    await onKeycloakReady();

    const accessToken = getToken();

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
      //config.headers['Authorization'] = `Bearer ${accessToken}`
    }

    // Nastavenie modu vyhladavanie podla UID
    config.headers['Ria-Search-Mode'] = 'UID';
    return config;
  },
  async function (error) {
    console.log(error.response.data);
    // Ak pride chyba 401
    if (error.response.status === 401 || error.response.data.message === '401 Unauthorized') {
      console.error('error code status => 401');
      await logoutFromApp();
      await router.push('');
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    if (error.response.status === 401 || error.response.data.message === '401 Unauthorized') {
      console.error('error code status => 401');
      await logoutFromApp();
      await router.push('');
    }

    // Ak pride chyba 403 - z dovodu nedostatocnej licencie
    if (
      error.response.status === 403 ||
      error.response.data === 'Neplatná, nedostatočná alebo chýbajúca licencia'
    ) {
      console.error('error code status => 403', error);
    }

    if (
      error.response.status === 500 ||
      error.response.data.message === '500 Internal Server Error'
    ) {
      console.error('error code status => 500', error);
      await router.push('/');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
